var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 861,
    viewBox: "0 0 467 861",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M715.257 238.987C854.802 366.325 913.78 565.124 857.351 705.896C775.535 910.034 439.119 991.782 244.172 803.426C17.0952 584.013 -5.16289 402.866 174.349 258.351C321.498 139.888 487.969 31.575 715.288 239.001L715.257 238.987Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.058 808.453C0.177338 588.378 2.56548 392.544 177.1 247.383C326.6 123.041 498.606 22.7859 719.354 237.716C854.551 369.106 915.052 575.975 852.09 719.555C764.991 918.123 438.111 985.206 243.027 808.439L243.058 808.453Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.882 813.452C-17.2465 592.96 10.1983 382.105 179.882 236.429C331.669 106.104 509.274 14.0107 723.452 236.444C854.345 371.87 916.537 586.847 846.842 733.183C754.845 926.317 436.545 979.046 241.927 813.435L241.882 813.452Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240.738 818.465C-35.1286 597.818 17.7633 371.487 182.65 225.505C336.676 89.139 519.928 5.26643 727.535 235.204C854.08 374.682 918.206 597.803 841.566 746.873C745.007 934.65 434.423 973.379 240.738 818.465Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M239.593 823.478C-53.5074 603.12 25.1879 360.769 185.401 214.537C341.584 71.9816 530.565 -3.52252 731.601 233.919C853.83 377.463 920.058 608.766 836.243 760.504C735.475 943.046 431.952 968.073 239.593 823.478Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.417 828.477C-72.2906 608.908 32.5617 349.917 188.183 203.583C346.413 54.7515 541.233 -12.2977 735.729 232.661C853.623 380.227 922.142 619.871 831.012 774.177C726.206 951.598 429.074 963.178 238.417 828.477Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.286 833.459C-91.5506 615.26 39.826 338.978 190.934 192.615C351.164 37.4489 551.856 -21.056 739.796 231.376C853.372 383.008 924.381 631.046 825.72 787.822C717.184 960.261 425.94 958.686 237.286 833.459Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M236.111 838.458C-111.192 622.294 46.9808 327.953 193.716 181.661C355.819 20.0291 562.523 -29.8311 743.893 230.105C853.166 385.773 926.853 642.363 820.458 801.481C708.35 969.083 422.577 954.537 236.111 838.458Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.966 843.47C-131.27 630.133 54.0879 316.869 196.453 170.724C360.32 2.53981 573.146 -38.5893 747.946 228.851C852.871 388.571 929.468 653.855 815.121 815.143C699.674 978.05 419.062 950.728 234.966 843.47Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233.821 848.483C-151.723 638.805 61.0993 305.668 199.235 159.77C364.77 -15.0836 583.814 -47.3644 752.043 227.579C852.651 391.366 932.316 665.49 809.859 828.802C691.168 987.131 415.407 947.227 233.821 848.483Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M232.646 853.482C-172.528 648.505 68.0043 294.456 201.986 148.802C369.049 -32.8215 594.451 -56.1535 756.14 226.308C852.414 394.116 935.324 677.345 804.598 842.461C682.731 996.391 411.707 944.076 232.646 853.482Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M760.224 225.068C852.18 396.942 938.476 689.377 799.322 856.151C674.42 1005.78 407.987 941.213 231.501 858.495C-193.624 659.262 74.8615 283.185 204.768 137.847C373.236 -50.6008 605.105 -64.8978 760.237 225.037L760.224 225.068Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/background-2.55fa8fbe93b256135c0c2029f1951617.svg";
export { ForwardRef as ReactComponent };